<template>
  <div>
    <div class="header mb-30">
      <div class="item">
        <p>历史发布话题</p>
        <p class="num">{{user.topicNum}}</p>
      </div>
      <div class="user">
        <div class="img">
          <img v-if="user.avatar" :src="user.avatar" alt="">
          <icon-svg v-else :icon-class="user.gender === 2 ? 'defaultWoman' : 'defaultMan'" class="head-default"></icon-svg>
        </div>
        <p class="name">{{user.nickName}}</p>
        <p class="company">{{user.stockjobber}}</p>
      </div>
      <div class="item">
        <p>历史参与话题</p>
        <p class="num">{{user.commentNum}}</p>
      </div>
      <!-- <div class="item">
        <p>历史参与问卷</p>
        <p class="num">15</p>
      </div> -->
      <!-- <div class="item">
        <p>好友粉丝数</p>
        <p class="num">15</p>
      </div> -->
    </div>
    <loading v-show="pageLoading" />
    <div class="user-topic" v-show="!pageLoading">
      <div class="left">
        <div class="title">
          <span class="line"></span>
          <span>历史发布话题（{{total}}）</span>
        </div>
        <div class="empty" v-show="list.length === 0">
          <icon-svg icon-class="noTopic" class="icon"></icon-svg>
          <p class="msg">下次再来看看吧，暂无话题</p>
        </div>
        <ul class="topic-list" v-show="list.length > 0">
          <li class="topic-item" @click="$router.push({ name: 'TopicDetail', params: { id: topic.id} })" v-for="(topic, idx) in list" :key="topic.id">
            <div class="content">
              <div class="item-title">
                <span class="index">{{(idx + 1) | changeIndex}}</span>
                <span class="line"></span>
                <h3 class="title-news">{{topic.title}}</h3>
              </div>
              <p class="msg ellipsis">{{topic.content}}</p>
              <div class="operation">
                <span class="time">{{topic.gmtCreate}}</span>
              </div>
            </div>
            <div class="comment-box">
              <span class="num">{{topic.commentNum}}</span>
              <icon-svg icon-class="comment" class="comment-svg"></icon-svg>
            </div>
          </li>
          <loading v-show="loading" />
          <div v-infinite-scroll="loadMoreFn" :infinite-scroll-disabled="busy" :infinite-scroll-immediate-check="false" infinite-scroll-distance="10" infinite-scroll-throttle-delay="300"></div>
        </ul>
      </div>
      <div class="side">
        <div class="item user">
          <div class="title">
            <span class="line"></span>
            <span>个人信息</span>
          </div>
          <ul>
            <li>
              <span>昵称</span>
              <span :title="user.nickName">{{user.nickName | noSetting}}</span>
            </li>
            <li>
              <span>性别</span>
              <span>{{user.gender | changeGender}}</span>
            </li>
            <li>
              <span>地址</span>
              <span v-if="address.length > 0">{{address.join(' - ')}}</span>
              <span v-else>未设置</span>
            </li>
            <li>
              <span>年龄</span>
              <span>{{user.age | noSetting}}</span>
            </li>
            <li>
              <span>学历</span>
              <span>{{user.education | noSetting}}</span>
            </li>
          </ul>
        </div>
        <div class="item company">
          <div class="title">
            <span class="line"></span>
            <span>公司信息</span>
          </div>
          <ul>
            <li>
              <span>所属证券公司</span>
              <span :title="user.stockjobber">{{user.stockjobber | noSetting}}</span>
            </li>
            <li>
              <span>所属营业部</span>
              <span :title="user.department">{{user.department | noSetting}}</span>
            </li>
            <li>
              <span>基金类别</span>
              <span :title="user.fundCategory">{{user.fundCategory | noSetting}}</span>
            </li>
            <li>
              <span>基金类型</span>
              <span :title="user.fundType">{{user.fundType | noSetting}}</span>
            </li>
            <li>
              <span>基金总净值</span>
              <span>{{user.fundTotal | noSetting}}{{user.fundTotal ? '万元' :' '}}</span>
            </li>
            <li>
              <span>从业年限</span>
              <span>{{user.fundYear | noSetting}}</span>
            </li>
            <li>
              <span>担任工作时长</span>
              <span>{{user.workYear | noSetting}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserInfo, getList } from '@/api/topic'
const cityList = require('@/assets/city/city.json')
export default {
  data () {
    return {
      id: '',
      user: {},
      address: [],
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      busy: false,
      loading: false,
      pageLoading: true
    }
  },
  created () {
    this.id = this.$route.query.id
    this.getUserData()
    this.getListData()
  },
  methods: {
    getUserData () {
      this.pageLoading = true
      getUserInfo(this.id).then(response => {
        const { data } = response
        this.user = data
        const { province, city } = this.user
        this.address = []
        cityList.forEach(element => {
          if (element.value === province) {
            this.address[0] = element.label
            element.children.forEach(child => {
              if (child.value === city) {
                this.address[1] = child.label
              }
            })
          }
        })
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.pageLoading = false
      })
    },
    loadMoreFn () {
      if ((this.pageNum > 1 && this.pageNum > Math.ceil(this.total / this.pageSize)) || this.busy) return
      // 多次加载数据
      this.getListData()
    },
    getListData () {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userId: this.id
        // tagId: this.tagId
      }
      this.loading = true
      this.busy = true
      getList(params).then(response => {
        const { data } = response
        if (this.pageNum === 1) {
          this.total = data.total
          this.list = []
        }
        this.pageNum++
        this.list = this.list.concat(data.list)
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.loading = false
        this.busy = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.header{
  margin-top: -30px;
  background: url('../../assets/images/userBg.jpg') no-repeat;
  background-size: 100% 200px;
  display: flex;
  justify-content: center;
  padding-top: 110px;
  .item{
    color: #FFF;
    text-align: center;
    font-size:16px;
    line-height: 18px;
    .num{
      font-size:32px;
      line-height:34px;
      margin-top: 16px;
    }
  }
  .user{
    margin: 0 100px;
    text-align: center;
    .img{
      width: 140px;
      height: 140px;
      border: 4px solid #FFF;
      background: #FFF;
      border-radius: 50%;
      overflow: hidden;
      img, .head-default{
        width: 100%;
        height: 100%;
      }
    }
    .name{
      color: #000;
      font-size: 24px;
      line-height: 26px;
      margin-bottom: 8px;
      margin-top: 20px;
    }
    .company{
      color: #929292;
      line-height: 16px;
    }
  }
}
.title{
  color: #000;
  font-size: 16px;
  font-weight: bold;
  height: 56px;
  display: flex;
  align-items: center;
  border-bottom: $border;
  .line{
    width: 4px;
    height: 16px;
    margin-right: 10px;
    background: #F5222D;
  }
}
.user-topic{
  display: flex;
  max-width: 1180px;
  margin: 0 auto;
  justify-content: center;
  .left{
    flex: 1;
    border:1px solid #ddd;
    border-top: 2px solid $blue;
    padding: 0 20px;
    border-radius:4px;
    .title{
      font-size: 18px;
      height: 78px;
      box-sizing: border-box;
      border-bottom: 0;
      .line{
        background: $blue;
        height: 18px;
      }
    }
    .empty{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .icon{
        width: 200px;
        height: 240px;
      }
      .msg{
        font-size:20px;
        font-weight:bold;
        color:#383838;
        line-height:80px;
      }
    }
    .topic-list{
      .topic-item{
        border-top: $border;
        padding: 26px 0;
        display: flex;
        overflow: hidden;
        cursor: pointer;
        .content{
          flex: 1;
          width: 0;
          .item-title{
            display: flex;
            align-items: center;
            .index{
              font-size:24px;
              font-family:ArialMT;
              font-weight:bold;
              color:#D3DBE6;
            }
            .line{
              flex-shrink: 0;
              width:4px;
              height:16px;
              background: $blue;
              margin: 0 25px 0 20px;
            }
          }
          .msg{
            line-height: 55px;
            font-weight:400;
            color: #666;
          }
          .operation{
            display: flex;
            align-items: center;
            .operation-btn{
              color: #666;
              display: flex;
              span{
                display: flex;
                align-items: center;
                cursor: pointer;
                &:last-child{
                  margin-left: 20px;
                }
              }
              .icon{
                width: 16px;
                height: 16px;
                margin-right: 10px;
                color: $blue;
              }
            }
            .status{
              width:60px;
              height:24px;
              line-height: 24px;
              border-radius:4px;
              margin-right: 20px;
              background:rgba(250,140,22,.15);
              text-align: center;
              display: inline-block;
              color: #FA8C16;
            }
            .time{
              color: #666;
              flex: 1;
            }
          }

        }
        .comment-num{
          width:60px;
          height:96px;
          background:rgba(255,255,255,0.1);
          border:1px solid rgba(245, 34, 45, 0.3);
          color: #F5222D;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-left: 36px;
          box-sizing: border-box;
          .num{
            font-size: 18px;
          }
          .icon{
            width: 30px;
            height: 30px;
            margin-top: 15px;
          }
        }
        &:last-child{
          border-bottom: none;
        }
      }
      li:last-child{
        background: red;
        border-bottom: 0;
      }
    }
  }
  .side{
    width: 280px;
    box-sizing: border-box;
    flex-shrink: 0;
    margin-left: 20px;
    .item{
      background:rgba(255,255,255,1);
      border:1px solid #ddd;
      border-top: 2px solid #F5222D;
      border-radius:4px;
      padding: 0 20px 12px;
      ul{
        padding-top: 15px;
        li{
          line-height: 34px;
          color: #383838;
          display: flex;
          span:first-child{
            color: #929292;
            width: 110px;
          }
          span:last-child{
            flex: 1;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
          }
        }
      }
      &.user{
        margin-bottom: 20px;
        ul > li{
          span:first-child{
            width: 70px;
          }
        }
      }
      &.company{
        border-top-color: #FA8C16;
        .line{
          background: #FA8C16;
        }
      }
    }
  }
}
</style>
